// extracted by mini-css-extract-plugin
module.exports = {"head":"_5b10bb2305--head--BY7Hh","content":"_5b10bb2305--content--H86EV"};